import {
  Redirect as RedirectRRD,
  useLocation,
} from "react-router-dom";
import { useSession } from "hooks";
import { environment } from "config/environment";

const Redirect = () => {
  const { loginExternal } = useSession()
  const loc = useLocation()

  const endToken = loc.hash.indexOf('&')
  const startToken = loc.hash.indexOf('=') + 1
  const token = loc.hash.substring(startToken, endToken)
  
  if (!environment.isProduction) {
    console.log({ loc })
  }
  
  if (token) {
    loginExternal({
      provider: 'facebook',
      token: token
    })
  }

  return <RedirectRRD to='/series' />
};

export default Redirect;
